import request from '../utils/fetch'
export function getCustomerServiceTelList (data) {
  return request({
    url: '/admin/customerService/get',
    method: 'get',
    requestBody: 'null',
    loading: true,
    params: data
  })
}
export function addTel (data) {
  return request({
    url: '/admin/customerService/add',
    method: 'get',
    requestBody: 'null',
    loading: true,
    params: data
  })
}
export function updateTel (data) {
  return request({
    url: '/admin/customerService/update',
    method: 'get',
    requestBody: 'null',
    loading: true,
    params: data
  })
}
export function delTel (data) {
  return request({
    url: '/admin/customerService/del',
    method: 'get',
    requestBody: 'null',
    loading: true,
    params: data
  })
}


